import { ReelBrandKitSkeleton } from '@/features/reels-brand-kit';
import { ReelSessionListSkeleton } from '@/features/reels-session-list';
// Deep import on purpose: the pages barrel is only ever reached through React.lazy.
import { ReelsWizardSkeleton } from '@/pages/ReelsCreator/ReelsWizardSkeleton';
import { useReelsRouteKind } from './reelsRouteKind';

/** The body each kind of Reels Creator page shows under its frame while access or the page loads. */
export const ReelsCreatorRouteFallback = () => {
  const kind = useReelsRouteKind();
  if (kind === 'home') return <ReelSessionListSkeleton />;
  if (kind === 'brands') return <ReelBrandKitSkeleton />;
  return <ReelsWizardSkeleton />;
};
